module.exports = __webpack_public_path__ + "static/media/ic_topup_request.02133869.png";